import { render, staticRenderFns } from "./modal_detallesElementos.vue?vue&type=template&id=47df7ae2&"
import script from "./modal_detallesElementos.vue?vue&type=script&lang=js&"
export * from "./modal_detallesElementos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports